import React from 'react';
import { Play, Stop, ArrowRotateLeft, Hourglass } from '@gravity-ui/icons';

const AdminCameraControls = ({ cameraId, managingCamera, onCameraAction }) => {
  const isLoading = managingCamera === cameraId;

  return (
    <div className="camera-controls">
      <button
        className="btn btn-sm btn-success"
        onClick={(event) => {
          event.stopPropagation();
          onCameraAction(cameraId, 'start');
        }}
        disabled={isLoading}
        title="Запустить"
      >
        {isLoading ? <Hourglass width={14} height={14} /> : <Play width={14} height={14} />}
      </button>
      <button
        className="btn btn-sm btn-danger"
        onClick={(event) => {
          event.stopPropagation();
          onCameraAction(cameraId, 'stop');
        }}
        disabled={isLoading}
        title="Остановить"
      >
        {isLoading ? <Hourglass width={14} height={14} /> : <Stop width={14} height={14} />}
      </button>
      <button
        className="btn btn-sm btn-warning"
        onClick={(event) => {
          event.stopPropagation();
          onCameraAction(cameraId, 'restart');
        }}
        disabled={isLoading}
        title="Перезапустить"
      >
        {isLoading ? <Hourglass width={14} height={14} /> : <ArrowRotateLeft width={14} height={14} />}
      </button>
    </div>
  );
};

export default AdminCameraControls;
